import { collection, doc, deleteDoc, getDocs } from 'firebase/firestore';
import { db } from '../../config';
import { syncHasSubPatterns } from './syncHasSubPatterns';

/**
 * 子パターンを1件削除する（#2967）。
 *
 * 論理削除ではなく物理削除にする。子パターンは監査ログ的な価値を持たない設定情報であり、
 * 残しても参照されないため（読取パターン本体の論理削除とは性格が異なる）。
 * 過去の結果には sub_pattern_name を非正規化して持たせているため、
 * 子パターンを消しても当時どの差分で処理したかの表示は保たれる。
 */
export const deleteSubPattern = async (patternId: string, subPatternId: string): Promise<void> => {
  await deleteDoc(doc(db, 'patterns', patternId, 'sub_patterns', subPatternId));
  await syncHasSubPatterns(patternId);
};

/**
 * 指定パターンの子パターンをすべて削除する（#2967）。
 * パターン削除時に呼ぶ。パターン本体は論理削除だが、サブコレクションは
 * 参照されなくなるため残さない（master_mappings の deleteMasterMappingsByPatternId と同じ流儀）。
 */
export const deleteSubPatternsByPatternId = async (patternId: string): Promise<void> => {
  const subPatternsRef = collection(db, 'patterns', patternId, 'sub_patterns');
  const snapshot = await getDocs(subPatternsRef);
  if (snapshot.empty) return;

  await Promise.all(snapshot.docs.map(d => deleteDoc(d.ref)));
};
